// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".titleOn[data-v-6ef309fe] {\n  border-radius: 10px !important;\n}\n.title-box[data-v-6ef309fe] {\n  color: #282828;\n  padding: 5px 10px;\n  background-repeat: no-repeat;\n}\n.ml6[data-v-6ef309fe] {\n  margin-left: 6px;\n}", ""]);
// Exports
module.exports = exports;
